import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { VgConstellationModule } from '../../shared/modules/vg-constellation/vg-constellation.module'
import { SortByTypeComponent } from '../sort-by-type/sort-by-type.component'
import { AppliedFilterComponent } from './applied-filter/applied-filter.component'
import { AssetClassStrategyFilterComponent } from './asset-class-strategy-filter/asset-class-strategy-filter.component'
import { FiltersComponent } from './filters.component'
import { ProductTypeFilterComponent } from './product-type-filter/product-type-filter.component'
import { CashEquivalentSubAssetFilterComponent } from './sub-asset-filter/cash-equivalent-sub-asset-filter/cash-equivalent-sub-asset-filter.component'
import { EquitySubAssetFilterComponent } from './sub-asset-filter/equity-sub-asset-filter/equity-sub-asset-filter.component'
import { FixedIncomeSubAssetFilterComponent } from './sub-asset-filter/fixed-income-sub-asset-filter/fixed-income-sub-asset-filter.component'
import { MultiAssetSubAssetFilterComponent } from './sub-asset-filter/multi-asset-sub-asset-filter/multi-asset-sub-asset-filter.component'
import { SubAssetFilterComponent } from './sub-asset-filter/sub-asset-filter.component'

@NgModule({
  declarations: [
    AssetClassStrategyFilterComponent,
    FiltersComponent,
    ProductTypeFilterComponent,
    SubAssetFilterComponent,
    SortByTypeComponent,
    EquitySubAssetFilterComponent,
    FixedIncomeSubAssetFilterComponent,
    MultiAssetSubAssetFilterComponent,
    CashEquivalentSubAssetFilterComponent,
    AppliedFilterComponent,
  ],
  imports: [CommonModule, VgConstellationModule, BrowserAnimationsModule],
  exports: [
    FiltersComponent,
    AssetClassStrategyFilterComponent,
    ProductTypeFilterComponent,
    SubAssetFilterComponent,
    EquitySubAssetFilterComponent,
    FixedIncomeSubAssetFilterComponent,
    MultiAssetSubAssetFilterComponent,
    CashEquivalentSubAssetFilterComponent,
    AppliedFilterComponent,
    SortByTypeComponent,
  ],
  bootstrap: [
    FiltersComponent,
    AssetClassStrategyFilterComponent,
    ProductTypeFilterComponent,
    SubAssetFilterComponent,
    EquitySubAssetFilterComponent,
    FixedIncomeSubAssetFilterComponent,
    MultiAssetSubAssetFilterComponent,
    CashEquivalentSubAssetFilterComponent,
  ],
})
export class FiltersModule {}
